module.exports = __webpack_public_path__ + "img/bg_zxhb.45f46b30.png";